function history(args) {
  return "history";
}

export { history };
